import { Sessions } from "../util/appointments";
import ColorUtil from "../util/ColorUtil";

/**
 * List of available theme color (fix for now?)
 */
export const ColorLists = [
	"#d0021b", "#f5a623", "#f8e71c", 
	"#8b572a", "#7ed321", "#bd10e0", 
	"#9013fe", "#4a90e2", "#00c4b3",
	"#50e3c2", "#000000", "#4a4a4a",
	"#9b9b9b", "#ffffff"
];
export const DataVisualizeKeys = {
	Primary: "primary",
	Secondary: "secondary",
};
export const DataVisualize = {
	primary:{
		main:["#00C4B3","#009384","#473793","#3C6DF0","#3B1A40"],
		data_border:"#187bae",
		content_border:"#00C4B3"
	},
	secondary:{
		main:["#9B82F3","#545799","#E64BE6","#DAA6F9","#9932D6"],
		data_border:"#FFFFFF",
		content_border:"#187bae"
	}
};
const Colors = {
	transparent:"rgba(1,1,1,0)",
	unimportantFontAlphaColor:"rgba(180,180,180,0.6)",
	greyFontColor:"#5a6872",
	backgroundColor:"#FFFFFF",
	hoverBackgroundColor:"#f2f4f5",
	greyBackgroundColor:"#d8d8d8",
	menuGreyBackgroundColor:"#32323b",
	mainColor: "#00c4b3", 
	subColor: "#0055b8",//'#1d90ff',
	antBlueColor:"#1890ff",
	blackColor:"#000000",
	red:"#F5222D",
	green:"#00C4B3",

	fontColor: "#000000",
	invertFontColor:"#FFFFFF",

	lightFontColor: "#b4b4b4",
	borderColor: "#e8e8e8",
	lightBorderColor: "#e2e2e2",
    
	button: { 
		textColor:"#FFFFFF"
	},
	loading: {
		backgroundColor:"rgba(255,255,255,0.75)"
	},
	data_visualize:DataVisualize,
};
export const StaticColor = {
	Sessions:{
		[Sessions.COMPLETED]:"#00c4b3",
		[Sessions.ONGOING]:"#005cac",
		[Sessions.PENDING]:"#f5a623",
		[Sessions.INCOMPLETED]:"#9b9b9b",
		[Sessions.CANCELLED]:"#f5222d"
	}
};
export default Colors;


// WEBPACK FOOTER //
// ./src/theme/Colors.js